import {
  identifyAnalyticsUser,
  resetAnalyticsUser,
  trackProductEvent,
  trackSignupMarketingConversion,
  type AnalyticsProperties,
} from '@/lib/analytics';
import type { User } from '@/types/auth';

export const identifyAuthenticatedUser = (user: Partial<User> & Record<string, unknown>) => {
  identifyAnalyticsUser(user);
};

export const resetAuthenticatedUser = () => {
  resetAnalyticsUser();
};

export const trackLogoutCompleted = () => {
  trackProductEvent('Logout Completed');
};

export const trackLoginCompleted = (properties: AnalyticsProperties) => {
  trackProductEvent('Login Completed', properties);
};

export const trackLoginOtpRequested = (properties: AnalyticsProperties) => {
  trackProductEvent('Login OTP Requested', properties);
};

export const trackOAuthAuthCompleted = (
  memberStatus: 'new' | 'existing' | undefined,
  properties: AnalyticsProperties
) => {
  trackProductEvent(memberStatus === 'new' ? 'Signup Completed' : 'Login Completed', properties);
};

export const trackSignupStarted = (properties: AnalyticsProperties) => {
  trackProductEvent('Signup Started', properties);
};

export const trackSignupSubmitted = (properties: AnalyticsProperties) => {
  trackProductEvent('Signup Submitted', properties);
};

export const trackSignupCompleted = (properties: AnalyticsProperties) => {
  trackProductEvent('Signup Completed', properties);
  trackSignupMarketingConversion(properties);
};
